export default "__VITE_ASSET__9067f102__"